import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell } from "recharts";
import { SalesTrend } from "@/hooks/useSalesForecast";

interface TrendsSectionProps {
  trends?: SalesTrend[];
}

export default function TrendsSection({ trends }: TrendsSectionProps) {
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>تحليل اتجاهات المبيعات</CardTitle>
          <CardDescription>
            نظرة شاملة على أداء المبيعات خلال آخر 12 شهر
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={400}>
            <BarChart data={trends}>
              <CartesianGrid strokeDasharray="3 3" opacity={0.1} />
              <XAxis dataKey="period_label" />
              <YAxis yAxisId="left" orientation="left" stroke="hsl(var(--primary))" />
              <YAxis yAxisId="right" orientation="right" stroke="hsl(var(--chart-2))" />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'hsl(var(--background))', 
                  border: '1px solid hsl(var(--border))',
                  borderRadius: '8px'
                }}
              />
              <Legend />
              <Bar 
                yAxisId="left" 
                dataKey="revenue" 
                fill="hsl(var(--primary))" 
                name="الإيرادات (ر.س)"
                radius={[8, 8, 0, 0]}
              />
              <Bar 
                yAxisId="right" 
                dataKey="bookings" 
                fill="hsl(var(--chart-2))" 
                name="عدد الحجوزات"
                radius={[8, 8, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>معدلات النمو الشهرية</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={trends}>
              <CartesianGrid strokeDasharray="3 3" opacity={0.1} />
              <XAxis dataKey="period_label" />
              <YAxis />
              <Tooltip 
                formatter={(value: number) => `${value.toFixed(1)}%`}
                contentStyle={{ 
                  backgroundColor: 'hsl(var(--background))', 
                  border: '1px solid hsl(var(--border))' 
                }}
              />
              <Bar dataKey="growth_rate" radius={[8, 8, 0, 0]}>
                {trends?.map((entry, index) => (
                  <Cell 
                    key={`cell-${index}`} 
                    fill={entry.growth_rate >= 0 ? 'hsl(var(--chart-1))' : 'hsl(var(--destructive))'} 
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </>
  );
}
